import { render, staticRenderFns } from "./logindev.vue?vue&type=template&id=435813c4&"
import script from "./logindev.vue?vue&type=script&lang=js&"
export * from "./logindev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports